import { Component } from '@angular/core';
import {NavigationUIComponent, IconComponent, GenericLinkComponent, NavigationNode} from '@spartacus/storefront';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';
import { SortPipe } from '@shared/pipes/sort.pipe';

@Component({
    selector: 'app-category-navigation-ui',
    templateUrl: './category-navigation-ui.component.html',
    imports: [IconComponent, NgTemplateOutlet, GenericLinkComponent, AsyncPipe, TranslatePipe, SortPipe]
})
export class CategoryNavigationUIComponent extends NavigationUIComponent {

  private getSanitizedTitle(title: string | undefined): string | null {
    return title ? title.replace(/\s+/g, '-').toLowerCase() : null;
  }
  /**
   * Returns the value for the `aria-control` and the `aria-label` attribute of a button.
   * @deprecated
   */
  getAriaLabelAndControl(node: NavigationNode): string | null {
    return this.getSanitizedTitle(node.title) || null;
  }
}
